import I18n, { getTranslationsFromContext } from 'v2/common/javascripts/i18n';

const context = require.context('v2/client/translations', false, /\.js$/);
const translations = getTranslationsFromContext(context);
I18n.translations = I18n.extend(I18n.translations, translations);

export default I18n;
